import { FaFile } from 'react-icons/fa6';
import { PeekLink } from '../../components/PeekLink';
import { ID } from '../../components/ID';
import { PageChips } from './PageChips';

interface SourceBlockProps {
  esn?: string;
  documentId: string;
  pageIds: string[];
}

export function SourceBlock({ esn, documentId, pageIds }: SourceBlockProps) {
  return (
    <div className="space-y-2">
      <div className="flex items-center gap-2 flex-wrap text-sm">
        {esn && (
          <>
            <span className="text-gray-500 dark:text-zinc-400">ESN</span>
            <span className="font-medium">{esn}</span>
            <span className="text-gray-300 dark:text-zinc-600">·</span>
          </>
        )}
        <span className="text-gray-500 dark:text-zinc-400">Doc</span>
        <PeekLink type="document" id={documentId} className="inline-flex items-center gap-1">
          <FaFile className="size-3.5" />
          <ID id={documentId} />
        </PeekLink>
        <span className="text-gray-300 dark:text-zinc-600">·</span>
        <span className="text-xs text-gray-500 dark:text-zinc-400">
          {pageIds.length} page{pageIds.length === 1 ? '' : 's'}
        </span>
      </div>
      <PageChips pageIds={pageIds} />
    </div>
  );
}
